<template>
    <span @click="showModal()" class="utc-link">
        <slot>{{ userTimezone.code }}</slot>
    </span>
</template>
<script>

// Import internal libraries
import Alert from '@/helpers/Alert.js';

// Import external libraries
import { mapState } from 'vuex';

export default {
    computed: {
        /**
         * State of user timezone
         *
         * userTimezone    State of the logged in user timezone
         */
        ...mapState('core/auth', [
            'userTimezone'
        ])
    },

    methods: {
        showModal () {
            Alert.showUtcModal(this.userTimezone.code, this.userTimezone.offset);
        }
    }
};
</script>
